// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Padding/Margin UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ENGINEERING NOTES
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    CSS padding syntax (https://www.w3schools.com/csS/css_padding.asp)
        Standards:
            Represent 0px as 0 (example: margin: 0;)
        Multiple-value padding statements:
            (1 value) padding: {top & right & left & bottom};
            (2 values) padding: {top} {bottom};
            (3 values) padding: {top} {right & left} {bottom};
            (4 values) padding: {top} {right} {bottom} {left};
        Other padding statements:
            padding-top: {top};
            padding-right: {right};
            padding-bottom: {bottom};
            padding-left: {left}
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* Padding */
.ezPad2 {
  padding: 2px;
}

.ezPad4 {
  padding: 4px;
}

.ezPad6 {
  padding: 6px;
}

.ezPad8 {
  padding: 8px;
}

.ezPad10 {
  padding: 10px;
}

.ezPad-top-2 {
  padding-top: 2px;
}

.ezPad-top-4 {
  padding-top: 4px;
}

.ezPad-bottom-4 {
  padding-bottom: 4px;
}

.ezPadding-bottom-0 {
  padding-bottom: 0;
}

.ezPadding-top-10 {
  padding-top: 10px;
}

.ezPadding-bottom-10 {
  padding-bottom: 10px;
}

.ezPadding-left-10 {
  padding-left: 10px;
}

.ezPadding-right-10 {
  padding-right: 10px;
}

.ezPadding-top-8 {
  padding-top: 8px;
}

.ezPadding-bottom-8 {
  padding-bottom: 8px;
}

.ezPadding-left-8 {
  padding-left: 8px;
}

.ezPadding-right-8 {
  padding-right: 8px;
}

.ezPadding-left-right-8 {
  padding-left: 8px;
  padding-right: 8px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    ENGINEERING NOTES
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    CSS margin syntax (https://www.w3schools.com/csS/css_margin.asp)
        Standards:
            Represent 0px as 0 (example: margin: 0;)
        Multiple-value margin statements:
            (1 value) margin: {top & right & left & bottom};
            (2 values) margin: {top} {bottom};
            (3 values) margin: {top} {right & left} {bottom};
            (4 values) margin: {top} {right} {bottom} {left};
        Other margin statements:
            margin-top: {top};
            margin-right: {right};
            margin-bottom: {bottom};
            margin-left: {left}
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* All Marigns */
.ezMargin_2x2x2x2 {
  margin: 4px;
}

.ezMargin_4x4x4x4 {
  margin: 4px;
}

.ezMargin_8x8x8x8 {
  margin: 8px;
}

.ezMargin_10x10x10x10 {
  margin: 10px;
}

.ezMargin_15x15x15x15 {
  margin: 15px;
}

.ezMargin_20x20x20x20 {
  margin: 20px;
}

/* Top Margins */
.ezTopMargin_2 {
  margin-top: 4px;
}

.ezTopMargin_4 {
  margin-top: 4px;
}

.ezTopMargin_8 {
  margin-top: 8px;
}

.ezTopMargin_10 {
  margin-top: 10px;
}

.ezTopMargin_15 {
  margin-top: 15px;
}

.ezTopMargin_20 {
  margin-top: 20px;
}

/* Bottom Margins */
.ezBottomMargin_2 {
  margin-bottom: 4px;
}

.ezBottomMargin_4 {
  margin-bottom: 4px;
}

.ezBottomMargin_8 {
  margin-bottom: 8px;
}

.ezBottomMargin_10 {
  margin-bottom: 10px;
}

.ezBottomMargin_15 {
  margin-bottom: 15px;
}

.ezBottomMargin_20 {
  margin-bottom: 20px;
}

/* Left Margins */
.ezLeftMargin_2 {
  margin-left: 4px;
}

.ezLeftMargin_4 {
  margin-left: 4px;
}

.ezLeftMargin_8 {
  margin-left: 8px;
}

.ezLeftMargin_10 {
  margin-left: 10px;
}

.ezLeftMargin_15 {
  margin-left: 15px;
}

.ezLeftMargin_20 {
  margin-left: 20px;
}

/* Right Margins */
.ezRightMargin_2 {
  margin-right: 4px;
}

.ezRightMargin_4 {
  margin-right: 4px;
}

.ezRightMargin_8 {
  margin-right: 8px;
}

.ezRightMargin_10 {
  margin-right: 10px;
}

.ezRightMargin_15 {
  margin-right: 15px;
}

.ezRightMargin_20 {
  margin-right: 20px;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 480px) {
}
*/
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 319px) {
}
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-padding.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;;;;;;;;;;;;;;;;;;CAAA;AAoBA,YAAA;AACA;EACI,YAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,oBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,kBAAA;AADJ;;AAKA;;;;;;;;;;;;;;;;;;CAAA;AAoBA,gBAAA;AACA;EACI,WAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,WAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ;;AAMA,gBAAA;AACA;EACI,eAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA,mBAAA;AACA;EACI,kBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA;EACI,mBAAA;AAHJ;;AAMA,iBAAA;AACA;EACI,gBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA,kBAAA;AACA;EACI,iBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;EACI,kBAAA;AAHJ;;AAMA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| EzClocker Padding/Margin UX CSS Classes\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    ENGINEERING NOTES\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    CSS padding syntax (https://www.w3schools.com/csS/css_padding.asp)\n        Standards:\n            Represent 0px as 0 (example: margin: 0;)\n        Multiple-value padding statements:\n            (1 value) padding: {top & right & left & bottom};\n            (2 values) padding: {top} {bottom};\n            (3 values) padding: {top} {right & left} {bottom};\n            (4 values) padding: {top} {right} {bottom} {left};\n        Other padding statements:\n            padding-top: {top};\n            padding-right: {right};\n            padding-bottom: {bottom};\n            padding-left: {left}\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n\n/* Padding */\n.ezPad2 {\n    padding: 2px;\n}\n\n.ezPad4 {\n    padding: 4px;\n}\n\n.ezPad6 {\n    padding: 6px;\n}\n\n.ezPad8 {\n    padding: 8px;\n}\n\n.ezPad10 {\n    padding: 10px;\n}\n\n.ezPad-top-2 {\n    padding-top: 2px;\n}\n\n.ezPad-top-4 {\n    padding-top: 4px;\n}\n\n.ezPad-bottom-4 {\n    padding-bottom: 4px;\n}\n\n.ezPadding-bottom-0 {\n    padding-bottom: 0;\n}\n\n.ezPadding-top-10 {\n    padding-top: 10px;\n}\n\n.ezPadding-bottom-10 {\n    padding-bottom: 10px;\n}\n\n.ezPadding-left-10 {\n    padding-left: 10px;\n}\n\n.ezPadding-right-10 {\n    padding-right: 10px;\n}\n\n.ezPadding-top-8 {\n    padding-top: 8px;\n}\n\n.ezPadding-bottom-8 {\n    padding-bottom: 8px;\n}\n\n.ezPadding-left-8 {\n    padding-left: 8px;\n}\n\n.ezPadding-right-8 {\n    padding-right: 8px;\n}\n\n.ezPadding-left-right-8 {\n    padding-left: 8px;\n    padding-right: 8px;\n}\n\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    ENGINEERING NOTES\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    CSS margin syntax (https://www.w3schools.com/csS/css_margin.asp)\n        Standards:\n            Represent 0px as 0 (example: margin: 0;)\n        Multiple-value margin statements:\n            (1 value) margin: {top & right & left & bottom};\n            (2 values) margin: {top} {bottom};\n            (3 values) margin: {top} {right & left} {bottom};\n            (4 values) margin: {top} {right} {bottom} {left};\n        Other margin statements:\n            margin-top: {top};\n            margin-right: {right};\n            margin-bottom: {bottom};\n            margin-left: {left}\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n\n/* All Marigns */\n.ezMargin_2x2x2x2 {\n    margin: 4px;\n}\n\n.ezMargin_4x4x4x4 {\n    margin: 4px;\n}\n\n.ezMargin_8x8x8x8 {\n    margin: 8px;\n}\n\n.ezMargin_10x10x10x10 {\n    margin: 10px;\n}\n\n.ezMargin_15x15x15x15 {\n    margin: 15px;\n}\n\n.ezMargin_20x20x20x20 {\n    margin: 20px;\n}\n\n/* Top Margins */\n.ezTopMargin_2 {\n    margin-top: 4px;\n}\n\n.ezTopMargin_4 {\n    margin-top: 4px;\n}\n\n.ezTopMargin_8 {\n    margin-top: 8px;\n}\n\n.ezTopMargin_10 {\n    margin-top: 10px;\n}\n\n.ezTopMargin_15 {\n    margin-top: 15px;\n}\n\n.ezTopMargin_20 {\n    margin-top: 20px;\n}\n\n/* Bottom Margins */\n.ezBottomMargin_2 {\n    margin-bottom: 4px;\n}\n\n.ezBottomMargin_4 {\n    margin-bottom: 4px;\n}\n\n.ezBottomMargin_8 {\n    margin-bottom: 8px;\n}\n\n.ezBottomMargin_10 {\n    margin-bottom: 10px;\n}\n\n.ezBottomMargin_15 {\n    margin-bottom: 15px;\n}\n\n.ezBottomMargin_20 {\n    margin-bottom: 20px;\n}\n\n/* Left Margins */\n.ezLeftMargin_2 {\n    margin-left: 4px;\n}\n\n.ezLeftMargin_4 {\n    margin-left: 4px;\n}\n\n.ezLeftMargin_8 {\n    margin-left: 8px;\n}\n\n.ezLeftMargin_10 {\n    margin-left: 10px;\n}\n\n.ezLeftMargin_15 {\n    margin-left: 15px;\n}\n\n.ezLeftMargin_20 {\n    margin-left: 20px;\n}\n\n/* Right Margins */\n.ezRightMargin_2 {\n    margin-right: 4px;\n}\n\n.ezRightMargin_4 {\n    margin-right: 4px;\n}\n\n.ezRightMargin_8 {\n    margin-right: 8px;\n}\n\n.ezRightMargin_10 {\n    margin-right: 10px;\n}\n\n.ezRightMargin_15 {\n    margin-right: 15px;\n}\n\n.ezRightMargin_20 {\n    margin-right: 20px;\n}\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 480px) {\n}\n*/\n\n/* -------------------------------------------------------------------\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 319px) {\n}\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
